function checkStickyHelper() {
    const header = document.getElementById('header');

    let existingHelper = header.querySelector('.sticky-helper');
    if (existingHelper) return existingHelper;

    const stickyHelper = document.createElement('div');
    stickyHelper.classList.add('sticky-helper');
    header.insertBefore(stickyHelper, header.firstElementChild);

    return stickyHelper;
}

function checkSticky(
    element,
    stickyClass,
    start,
    generateStickyHelper = true,
    originalHeight
) {
    const scrollPos = window.scrollY;
    const header = document.getElementById("header");
    const alreadySticky = header.classList.contains(stickyClass);

    if (scrollPos > start) {
        if (!alreadySticky) {
            header.classList.add("is-sticking");

            setTimeout(() => {
                header.classList.add(stickyClass);

                setTimeout(() => {
                    header.classList.remove("is-sticking");
                }, 20);
            }, 20);
        }

        if (generateStickyHelper) {
            let stickyHelper = header.querySelector('.sticky-helper');
            if (!stickyHelper) {
                stickyHelper = checkStickyHelper();
            }
            stickyHelper.style.height = originalHeight + "px";
        }
    } else {
        if (alreadySticky) {
            header.classList.remove(stickyClass, 'is-sticking');
        }

        const stickyHelper = header.querySelector('.sticky-helper');
        if (stickyHelper) {
            stickyHelper.style.height = "0px";
        }
    }
}

export function stickyElement(element, elementTrigger, generatePlaceholder = false, isMobile = true) {
    if (!element) {
        console.error("cannot find sticky element");
        return;
    }

    let stickyClass = "sticky";
    const originalHeight = element.offsetHeight;
    let elementBounding = element.getBoundingClientRect();
    let elementStyle = element.currentStyle || window.getComputedStyle(element);
    let start = window.scrollY + elementBounding.y + parseInt(elementStyle.marginTop);

    if (isMobile) {
        elementBounding = elementTrigger.getBoundingClientRect();
        start = window.scrollY + elementBounding.y;
    }

    checkSticky(element, stickyClass, start, generatePlaceholder, originalHeight);

    window.addEventListener("scroll", () => {
        checkSticky(element, stickyClass, start, generatePlaceholder, originalHeight);
    });
}

export function calculateStickyTop(stickyElement, offset = 0, headerArea) {
    function calculateHeightAndResize(element) {
        const headerHeight = headerArea.getBoundingClientRect().height + offset;
        element.style.top = headerHeight + 'px';
    }

    if (stickyElement) {
        if (stickyElement.style.position !== 'sticky') {
            stickyElement.style.position = 'sticky';
        }
        calculateHeightAndResize(stickyElement);

        window.addEventListener('resize', () => {
            calculateHeightAndResize(stickyElement);
        });
    }
}